var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblePointBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 9,
    viewBox: "0 0 34 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Point / Bottom-grey"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M19.5012 6.44922L14.3012 -0.000781536H24.7012L19.5012 6.44922Z",
    fill: "#FF3D8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M14 0.408836L18.5781 6.02746C19.0873 6.6523 19.9127 6.6523 20.4219 6.02747L25 0.408836",
    stroke: "#FF3D8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblePointBottom);
export default __webpack_public_path__ + "static/media/bubble-point-bottom.61c9378143635e558242e55be4d6e875.svg";
export { ForwardRef as ReactComponent };